export const SupplementalInsuranceInfo = {
  TITLE: 'Supplemental Insurance',
  KEY: 'supplementalInsurances',
  PENDING_CHANGES_KEY: 'supplementalInsurancesPendingChanges',
};

export const TableColumnId = {
  IMPOUND_TYPE_ID: 'impoundTypeId',
  MONTHLY_AMOUNT: 'monthlyAmount',
};

export const defaultSortOrder = {
  direction: 'desc',
  id: 'name',
};
